import { render, staticRenderFns } from "./ServiceDetailInfo.vue?vue&type=template&id=625222ee&scoped=true&"
import script from "./ServiceDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetailInfo.vue?vue&type=style&index=0&id=625222ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625222ee",
  null
  
)

export default component.exports